module.exports = fox._r("images/here-we-go.png", __webpack_public_path__ + "_/_/_/common/frame/images/here-we-go.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/images/here-we-go.png
// module id = 134
// module chunks = 2